class CustomDeliveryDate extends HTMLElement {
  constructor() {
    super();
    // recuperation des noeuds
    this.inputMin = this.querySelector("input[name='attributes[dal_min]']");
    this.inputMax = this.querySelector("input[name='attributes[dal_max]']");
    this.label = this.querySelector("label");
    this.text = this.getAttribute("data-text") || "";
    this.textSingle = this.getAttribute("data-text-single") || this.text;
    this.shop = (this.getAttribute("shop") || "").replace(/\.myshopify\.com$/i, '');

    // Execution initiale avec cart provenant du template
    this.getDeliveryDate(window.cart);

    // Ecoute les changements du panier
    this.debouncedOnUpdate = this.debounce(() => this.getCart(), 50);
    document.addEventListener('cart:updated', this.debouncedOnUpdate.bind(this));
    document.addEventListener('cart-dep:updated', this.debouncedOnUpdate.bind(this));
  }

  /**
   * fonction de debouncce
   * @param {*} fn
   * @param {*} wait
   * @returns
   */
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  /**
   * ?ise a jour des infos de delivery
   * @param {*} cart - contenu du panier
   * @returns
   */
  async getDeliveryDate(cart = {}) {
    if (cart.items && cart.items.length) {
      let res;
      try {
        const response = await fetch("https://api.willemse.com/bamboo/dep-dal", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            'Ocp-Apim-Subscription-Key': this.getAttribute("wak")
          },
          body: JSON.stringify({
            produits: cart.items.map(({ sku, quantity }) => ({ sku, qte: quantity })),
            shop: this.shop
          }),
          mode: "cors",
        });

        if (!response.ok) return;

        res = await response.json();
      } catch (e) {
        console.error(e);
        return;
      }

      const { dalMin, dalMax } = res.dals?.[0] ?? {};

      if (!dalMin || !dalMax) return;

      let userLang = Intl.DateTimeFormat().resolvedOptions().locale;
      const dateMin = new Date(dalMin).toLocaleDateString(userLang);
      const dateMax = new Date(dalMax).toLocaleDateString(userLang);
      const text = dateMin === dateMax ? this.textSingle : this.text;
      this.inputMin.value = dalMin;
      this.inputMax.value = dalMax;
      this.label.textContent = text.replace(/\{\{\s?dal_min\s?\}\}/i, dateMin).replace(/\{\{\s?dal_max\s?\}\}/i, dateMax);
      return;
    }

    this.inputMin.value = null;
    this.inputMax.value = null;
    this.label.textContent = "";
  }

  async getCart() {
    const cartData = await fetch('/cart.js').then((response) => response.json());
    this.getDeliveryDate(cartData);
  }
}

customElements.define("custom-delivery-date", CustomDeliveryDate);
